angular.module('impactx.search').component('ixSupplierItemActions', {
        bindings: {
            supplier: '<'
        },
        controller: 'SupplierItemActionCtrl',
        controllerAs: 'actionsCtrl',
        templateUrl: 'modules/search/templates/supplier-item-actions.html'
    }
);